import { useQuery } from '@tanstack/react-query';
import { getLegacyRoleDefinitions } from '../../utils/principal-service/legacy-role-definition-endpoints';
import { RoleDefinitions } from '../../utils/types';

export function useRoleDefinitions(): RoleDefinitions {
  const { data: legacyRoleDefinitions } = useQuery({
    queryFn: getLegacyRoleDefinitions,
    queryKey: ['legacy-role-definitions'],
    initialData: {} as RoleDefinitions,
  });
  return legacyRoleDefinitions;
}
